module.exports = __webpack_public_path__ + "static/img/new_thumb5.80289ad.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new_thumb5.jpg
// module id = 1m+2
// module chunks = 0